import React from "react";
import { gql } from "graphql-tag";
import { useQuery } from "@apollo/client";
import css from "classnames";
import { getTeamByOrgId, getTeamByOrgIdVariables } from "types/gql-types";
import { LinkButton } from "components/haven-design/buttons";
import { ServerError, LoadingSpinner } from "components/graphql-views";
import { Viewer } from "components/auth/types";
import TeamTable from "./team-table";
import styles from "./team-table.module.css";


const TEAM_BY_ORG = gql`
  query getTeamByOrgId($id: ID!) {
    organization(id: $id) {
      id
      name
      team {
        id
        fullName
        email
        roles
        directPhone
        title
      }
    }
  }
`;

interface Props {
  path: string;
  viewer: Viewer;
}

const TeamSettingsPage: React.FC<Props> = (props: Props) => {
  const orgId = props.viewer.organizationId;
  if (!orgId) return <ServerError desc="Missing Data" />;
  const { data, loading, error } = useQuery<getTeamByOrgId, getTeamByOrgIdVariables>(TEAM_BY_ORG, {
    fetchPolicy: "cache-and-network",
    variables: { id: orgId },
  });

  if (error) return <ServerError desc={error.message} />;
  if (loading) return <LoadingSpinner />;
  if (!data) return <ServerError desc="Missing Data" />;
  const { organization: { team: users } } = data;

  return (
    <div style={{ width: "100%" }}>
      <div className={css(styles.header, "margin-bottom-l")}>
        <h2 className={styles.title}>Team Settings</h2>
        <div className={styles.buttons}>
          <LinkButton
            to="/dash/manager/settings/team/new"
            size="L"
            color="primary"
          >
            Invite
          </LinkButton>
        </div>
      </div>
      <TeamTable rowData={users} />
    </div>

  );
};

export default TeamSettingsPage;
